var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.7,
    height: 17.7,
    viewBox: "0 0 23.7 17.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(-0.15 -3.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2707",
    "data-name": "Group 2707"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M12,3.15a10.437,10.437,0,0,1,5.082,1.356,15.022,15.022,0,0,1,3.663,2.913,19.7,19.7,0,0,1,3.015,4.2.85.85,0,0,1,0,.76,19.7,19.7,0,0,1-3.015,4.2,15.022,15.022,0,0,1-3.663,2.913A10.437,10.437,0,0,1,12,20.85a10.437,10.437,0,0,1-5.082-1.356,15.022,15.022,0,0,1-3.663-2.913A19.7,19.7,0,0,1,.24,12.38a.85.85,0,0,1,0-.76,19.7,19.7,0,0,1,3.015-4.2A15.022,15.022,0,0,1,6.918,4.506,10.437,10.437,0,0,1,12,3.15ZM22.032,12a18.887,18.887,0,0,0-2.557-3.451A13.282,13.282,0,0,0,16.24,5.983,8.751,8.751,0,0,0,12,4.85C6.442,4.85,2.844,10.47,1.968,12a18.887,18.887,0,0,0,2.557,3.451A13.282,13.282,0,0,0,7.76,18.017,8.751,8.751,0,0,0,12,19.15C17.558,19.15,21.156,13.53,22.032,12Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    d: "M3-.85A3.85,3.85,0,1,1-.85,3,3.854,3.854,0,0,1,3-.85Zm0,6A2.15,2.15,0,1,0,.85,3,2.152,2.152,0,0,0,3,5.15Z",
    transform: "translate(9 9)",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.24875a3c42eaa9a0a15b3d9cb02a323f.svg";
export { ForwardRef as ReactComponent };